import { render } from "./main-algolia.vue?vue&type=template&id=ec0d3b7a"
import script from "./main-algolia.vue?vue&type=script&lang=js"
export * from "./main-algolia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__